import { useEffect, useState, useCallback } from 'react';
import { scrollIntoView } from 'utils/dom';
import {
  Container,
  MainContainer,
  SidebarContainer,
  WorldClocks,
  ButtonContainer,
  Button,
  WelcomeContainer,
  WelcomeText,
  WelcomeLabel,
  GuestName,
  WelcomeNoteContainer,
  NoteWelcomeText,
  HederContainer,
  WeatherBox,
  Temperature,
  WeatherRow,
  Superscript,
  WelcomeWrapper,
  DateText,
  TimeText,
  DateTimeContainer,
  ClockDisplayContainer,
  ClockCityName,
  ClockContainer,
} from './styles';
import { ImageBox } from 'components/styles/Common.styled';
import { translate as t } from 'utils/i18n';
import {
  getCurrentDateTime,
  getDateInTimeZone,
  getWeatherDetail,
  getWelcomeNoteData,
  parseWeatherDetails,
  resolveLocationTimeZone,
} from '../common/utils';
import { MenuModalItemIcon } from '../common/styles';
import StorageKeys from 'enum/storages.enum';
import Storages from 'storages';
import DeafultTimeZone from 'components/time/defaultTimeZone';
import EventBus from 'utils/eventBus';
import Clock from 'react-clock';
import { useCachedImageSrc } from 'utils/cache/imageResolver';

export default function Blue(props) {
  const [dateTime, setDateTime] = useState({
    city1: { name: '', date: '', time: '', dateTime: new Date() },
    city2: { name: '', date: '', time: '', dateTime: new Date() },
    city3: { name: '', date: '', time: '', dateTime: new Date() },
  });
  const [welcomeNote, setWelcomeNote] = useState('');
  const [profileImageRawUrl, setProfileImageRawUrl] = useState(null);
  const [weatherData, setWeatherData] = useState({ temp: '', humidity: '', condition: '' });
  const [locations, setLocations] = useState([]);

  // useCachedImageSrc handles AWS pre-sign refresh, demo-mode IndexedDB caching,
  // periodic re-resolve, and blob URL revocation. The hook returns null until
  // the first resolution completes.
  const profileImageSrc = useCachedImageSrc(profileImageRawUrl);

  const getData = useCallback(() => {
    handleWeather();
    handleWelcomeNote();
    //TODO: enable after fixing
    handleImge();
  }, []);
  useEffect(() => {
    const getTime = async () => {
      try {
        const locations = Storages.MainStorage.getItem(StorageKeys.Keys.ORGANIZATIONLOCATIONS) || [];
        setLocations(locations);

        // Map each location — zone field names differ by API version
        const locationsData = locations.map((location) => ({
          zone: resolveLocationTimeZone(location),
          city: location?.city_name || '',
        }));

        const estTime = new Date();
        const mainLocation = locationsData[0]?.zone || DeafultTimeZone.new_york;
        const mainDateTime = await getCurrentDateTime(mainLocation);
        const mainCityTime = getDateInTimeZone(estTime, mainLocation);

        const additionalLocations = locationsData.slice(1);
        const worldClockData = {};
        const maxWorldClocks = 3;
        for (let i = 0; i < Math.min(additionalLocations.length, maxWorldClocks); i++) {
          const location = additionalLocations[i];
          const timezone = location?.zone || DeafultTimeZone.new_york;
          const cityDateTime = await getCurrentDateTime(timezone);
          const cityTime = getDateInTimeZone(estTime, timezone);

          worldClockData[`worldCity${i + 1}`] = {
            name: location?.city || '',
            date: cityDateTime.date,
            time: cityDateTime.time,
            dateTime: cityTime,
            timezone: timezone,
          };
        }

        setDateTime(
          Object.assign(
            {},
            {
              city1: {
                name: locationsData[0] && locationsData[0].city ? locationsData[0].city : undefined,
                date: mainDateTime.date,
                time: mainDateTime.time,
                dateTime: mainCityTime,
                timezone: mainLocation,
              },
            },
            worldClockData
          )
        );
      } catch (err) {
        console.warn('Blue getTime failed:', err && err.message);
        // Last resort — still show device local time so sidebar is never blank
        try {
          const fallback = await getCurrentDateTime();
          setDateTime({
            city1: {
              name: '',
              date: fallback.date,
              time: fallback.time,
              dateTime: new Date(),
              timezone: DeafultTimeZone.new_york,
            },
          });
        } catch (e2) {}
      }
    };

    const tickAnalogClocks = () => {
      setDateTime(function (prev) {
        if (!prev) return prev;
        var now = new Date();
        var next = {};
        var keys = Object.keys(prev);
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          var city = prev[key];
          if (!city) {
            next[key] = city;
            continue;
          }
          if (city.timezone) {
            next[key] = Object.assign({}, city, {
              dateTime: getDateInTimeZone(now, city.timezone),
            });
          } else {
            next[key] = city;
          }
        }
        return next;
      });
    };

    const onRefreshSub = EventBus.subscribe('refresh', () => {
      getData();
    });
    getData();
    // Digital time / locations: every minute; analog second hand: every second
    const timeInterval = setInterval(() => {
      getTime();
    }, 10000 * 6);
    const tickInterval = setInterval(tickAnalogClocks, 1000);
    getTime();

    return () => {
      clearInterval(timeInterval);
      clearInterval(tickInterval);
      onRefreshSub.unsubscribe();
    };
  }, [getData]);

  const handleWeather = async () => {
    const lang = Storages.MainStorage.getItem(StorageKeys.Keys.LANGUAGECODE)?.split('_')[0] || 'en';
    const location =
      Storages.MainStorage.getItem(StorageKeys.Keys.CURRENTLOCATION)?.city_name ||
      DeafultTimeZone.new_york;
    const weatherDetails = await getWeatherDetail(location, lang);
    if (weatherDetails == null) return
    const parsedDetails = parseWeatherDetails(weatherDetails);
    setWeatherData(parsedDetails);
  };

  const handleWelcomeNote = () => {
    const locale_note = getWelcomeNoteData();
    const firstNote = locale_note
      ? `${locale_note[0]?.locale_welcome_note?.locale_description || ''}`
      : '';
    setWelcomeNote(firstNote);
  };

  const handleImge = () => {
    const res = Storages.MainStorage.getItem(StorageKeys.Keys.PROFILECATEGORY);
    if (res === null) {
      setProfileImageRawUrl(null);
      return;
    }
    const profile = Storages.MainStorage.getItem(StorageKeys.Keys.PROFILE + res[0]?.id);
    setProfileImageRawUrl(profile?.image || null);
  };

  useEffect(() => {
    scrollIntoView('.main-menu-button', props.focusedIndex);
  }, [props.focusedIndex, props.mainMenuList]);

  return (
    <Container>
      <MainContainer>
        <HederContainer>{/* <Logo /> */}</HederContainer>
        <WelcomeWrapper isRTL={props.isRTL}>
          {props.customerData?.guest_name && (
            <WelcomeContainer isRTL={props.isRTL}>
              <WelcomeText isRTL={props.isRTL}>
                <WelcomeLabel>{t('WelcomeNote.welcome')}</WelcomeLabel>
                <GuestName>{props.customerData?.guest_name || ''}</GuestName>
              </WelcomeText>
            </WelcomeContainer>
          )}
          {welcomeNote && (
            <WelcomeNoteContainer isRTL={props.isRTL}>
              <NoteWelcomeText>{welcomeNote}</NoteWelcomeText>
            </WelcomeNoteContainer>
          )}
        </WelcomeWrapper>
        <ButtonContainer className='barless-scroll-container' dir={props.isRTL ? 'rtl' : undefined}>
          {(props.mainMenuList ?? []).map((item, index) => (
            <Button
              className='main-menu-button'
              key={item.id}
              onClick={() => props.updateMenuList(index, true, true)}
              active={item.active}
              ref={(el) => {
                if (index === props.focusedIndex && el) el.focus();
              }}
            >
              <MenuModalItemIcon active={item.active}>
                <i className={item.icon}></i>
              </MenuModalItemIcon>
              {item.title}
            </Button>
          ))}
        </ButtonContainer>
      </MainContainer>

      <SidebarContainer>
        <DateTimeContainer>
          <TimeText>{dateTime.city1.time}</TimeText>
          <DateText>{dateTime.city1.date}</DateText>
        </DateTimeContainer>

        <WeatherBox>
          <Temperature>
            {`${weatherData.temp} `}
            <Superscript>{t('Weather.degreeCentigrade')}</Superscript>
          </Temperature>
          <WeatherRow>
            <div>{`${t('Weather.humidity')}: ${weatherData.humidity}%`}</div>
          </WeatherRow>
          <WeatherRow>
            <div>{`${t('Weather.description')}: ${weatherData.condition}`}</div>
          </WeatherRow>
        </WeatherBox>

        {locations && locations.length > 1 && (
          <WorldClocks>
            {/* <h3>{t('Time.worldClocks')}</h3> */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '0.5rem',
                width: '90%',
                flexWrap: 'nowrap',
                overflow: 'hidden',
              }}
            >
              {Object.entries(dateTime)
                .filter(([key, city]) => key.startsWith('worldCity') && city.name && city.dateTime)
                .map(([key, city], index) => (
                  <ClockDisplayContainer key={`${city.name}-${index}`}>
                    <ClockCityName>{city.name}</ClockCityName>
                    <ClockContainer>
                      <Clock
                        className=''
                        value={city.dateTime}
                        renderSecondHand={true}
                        secondHandLength={90}
                        secondHandWidth={2}
                      />
                    </ClockContainer>
                  </ClockDisplayContainer>
                ))}
            </div>
          </WorldClocks>
        )}

        {profileImageSrc && <ImageBox image={profileImageSrc} height='100%'></ImageBox>}
      </SidebarContainer>
    </Container>
  );
}
